import { AuthTokenStructure } from 'api/types';
import jwtDecode from 'jwt-decode';

export const decodeAuthToken = (token: string) => {
    try {
        return jwtDecode<AuthTokenStructure>(token);
    } catch (e) {
        console.error('Ошибка при декодировании Auth Token', e);
        return null;
    }
};
